// tpkw-script.js

document.addEventListener('DOMContentLoaded', () => {
  // -----------------------------
  // Helpers
  // -----------------------------
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

  // -----------------------------
  // Mobile Nav Toggle
  // -----------------------------
  const nav = $('.nav');
  const navToggle = $('.nav-toggle');

  if (nav && navToggle) {
    navToggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('nav-open');
      navToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  // -----------------------------
  // Account Modal (profile button)
  // Works with both plain HTML + Shopify customer logic
  // -----------------------------
  const profileBtn = $('.profile-btn');
  const accountModal = $('.account-modal');
  const accountPanel = accountModal ? $('.account-panel', accountModal) : null;
  const closeModalBtn = accountModal ? $('.close-modal', accountModal) : null;

  const openModal = () => {
    if (!accountModal) return;
    accountModal.classList.add('open');
    accountModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
  };

  const closeModal = () => {
    if (!accountModal) return;
    accountModal.classList.remove('open');
    accountModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
  };

  if (profileBtn && accountModal) {
    profileBtn.addEventListener('click', () => {
      // If customer is logged in, Shopify may be rendering only details,
      // but we still just open the modal.
      if (accountModal.classList.contains('open')) {
        closeModal();
      } else {
        openModal();
      }
    });
  }

  if (closeModalBtn) {
    closeModalBtn.addEventListener('click', () => {
      closeModal();
    });
  }

  // Close when clicking outside the account panel
  if (accountModal && accountPanel) {
    accountModal.addEventListener('click', (event) => {
      if (!accountPanel.contains(event.target)) {
        closeModal();
      }
    });
  }

  // Close on Escape key
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && accountModal && accountModal.classList.contains('open')) {
      closeModal();
    }
  });

  // -----------------------------
  // Account Tabs (Login / Register)
  // This will only run if those elements exist.
  // -----------------------------
  const accountTabsWrapper = $('.account-tabs');
  if (accountTabsWrapper) {
    const tabButtons = $$('[data-tab]', accountTabsWrapper);
    const forms = $$('.account-form');
    const detailsPanel = $('.account-details');

    tabButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = btn.getAttribute('data-tab');
        if (!target) return;

        // Toggle active tab button
        tabButtons.forEach((b) => b.classList.toggle('active', b === btn));

        // If we have login/register forms
        if (forms.length) {
          forms.forEach((form) => {
            const formKey = form.getAttribute('data-form');
            if (!formKey) return;
            if (formKey === target) {
              form.classList.remove('hidden');
            } else {
              form.classList.add('hidden');
            }
          });
        }

        // If there is an account-details section and a tab for "details"
        if (detailsPanel) {
          if (target === 'details') {
            detailsPanel.classList.remove('hidden');
            forms.forEach((form) => form.classList.add('hidden'));
          } else {
            detailsPanel.classList.add('hidden');
          }
        }
      });
    });
  }

  // -----------------------------
  // Booking Form (optional UX)
  // You can hook this into an app, email, or backend later.
  // For now we just prevent default and show a simple alert.
  // -----------------------------
  const bookingForm = $('.booking-form');
  if (bookingForm) {
    bookingForm.addEventListener('submit', (event) => {
      // Remove this line if you connect to a real endpoint or app:
      event.preventDefault();

      const name = $('input[type="text"]', bookingForm)?.value || 'love';
      alert(`Thank you, ${name}! Your request has been received. ✨`);

      bookingForm.reset();
    });
  }

  // -----------------------------
  // Dynamic Year in Footer
  // -----------------------------
  const yearSpan = $('#year');
  if (yearSpan) {
    yearSpan.textContent = new Date().getFullYear();
  }

  // -----------------------------
  // Moon Phase Indicator
  // -----------------------------
  const moonPhaseEl = $('.moon-phase');

  function getMoonPhase(date = new Date()) {
    // Simple approximate algorithm:
    //  - Use a known new moon reference, then compute days since, mod 29.53 days.
    const synodicMonth = 29.53058867; // days
    const knownNewMoon = new Date('2000-01-06T18:14:00Z').getTime(); // reference new moon
    const diff = date.getTime() - knownNewMoon;
    const daysSinceNew = diff / (1000 * 60 * 60 * 24);
    const currentPhase = daysSinceNew % synodicMonth;

    if (currentPhase < 1.84566) return 'New Moon';
    if (currentPhase < 5.53699) return 'Waxing Crescent';
    if (currentPhase < 9.22831) return 'First Quarter';
    if (currentPhase < 12.91963) return 'Waxing Gibbous';
    if (currentPhase < 16.61096) return 'Full Moon';
    if (currentPhase < 20.30228) return 'Waning Gibbous';
    if (currentPhase < 23.99361) return 'Last Quarter';
    if (currentPhase < 27.68493) return 'Waning Crescent';
    return 'New Moon';
  }

  if (moonPhaseEl) {
    try {
      moonPhaseEl.textContent = getMoonPhase();
    } catch (e) {
      moonPhaseEl.textContent = 'Cosmic';
    }
  }
});